import FaqList from 'components/blog/Faq'
import Link from 'next/link'

export default function Faq() {
  return (
    <section className="relative bg-white bg-center overflow-hidden font-['Inter']">
      <div className="bg-transparent">
        <div className="relative mt-16 pt-16 md:pt-24 pb-20 md:pb-28">
          <div className="container max-w-5xl px-4 mx-auto">
            <div className="relative flex flex-wrap justify-center -mx-4">
              <div className="w-full px-4 mb-12 md:mb-0 text-center">
                <h1 className="hero-top-title" tabIndex={0}>
                  Frequently Asked Questions
                </h1>
                <p className="mb-12 md:mb-16 body-text mt-12" tabIndex={0}>
                  Helpful answers to your most common questions.
                </p>
                <div className="w-full px-10 text-left">
                  <FaqList faqName="ckan-general" variant="page" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className='bg-white mt-0 mb-12 relative w-screen max-w-screen overflow-hidden' tabIndex={0}>
          <h3 className='text-center mx-auto medium-title font-["Inter"] text-white'>Still have questions?</h3>
          <p className='text-center font-["Inter"] text-maingray mt-4 px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>We&apos;re here to help! Contact us now.</p>
          <div className='flex flex-col sm:flex-row mt-8 gap-y-8 sm:gap-x-8 w-full justify-center px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>
            <div className='btn-primary'><Link href="/contact">Contact Us</Link></div>
            <div className='btn-primary'><Link href="https://calendar.app.google/LT4acVdKn3Cxm2MXA" target="_blank">Schedule a free call</Link></div>
          </div>
        </section>
      </div>
    </section>
  )
}
